import {
	type ProjectType,
	SOFTWARE_PROJECT,
} from '@jira/platform__project-types/src/project-types.tsx';

export const isJiraSoftware = (projectType: ProjectType | undefined) =>
	projectType && projectType === SOFTWARE_PROJECT;
